import React from 'react';
import Reader from '../utils/reader/reader';

export type PlaybackState = {
  isPlaying: boolean;
  isPaused: boolean;
  currentIndex: number;
  totalChunks: number;
  currentSentence: string;
  scriptureTitle: string;
  scriptureSubtitle: string;
  playbackRate: number;
  volume: number;
  isMuted: boolean;
  backgroundMusicEnabled: boolean;
  visible: boolean;
};

export interface IPlaybackContext {
  state: PlaybackState;
  reader: Reader | null;
  play: (sentences: string[], lang: string, title: string, subtitle: string) => void;
  pause: () => void;
  resume: () => void;
  stop: () => void;
  nextChunk: () => void;
  prevChunk: () => void;
  seekToChunk: (index: number) => void;
  setPlaybackRate: (rate: number) => void;
  setVolume: (volume: number) => void;
  toggleMute: () => void;
  toggleBackgroundMusic: () => void;
  dismiss: () => void;
  registerScrollCallback: (cb: ((index: number) => void) | null) => void;
  scrollToCurrent: () => void;
}

const defaultState: PlaybackState = {
  isPlaying: false,
  isPaused: false,
  currentIndex: 0,
  totalChunks: 0,
  currentSentence: '',
  scriptureTitle: '',
  scriptureSubtitle: '',
  playbackRate: 0.85,
  volume: 1,
  isMuted: false,
  backgroundMusicEnabled: true,
  visible: false,
};

export const PlaybackContext = React.createContext<IPlaybackContext>({
  state: defaultState,
  reader: null,
  play: () => {},
  pause: () => {},
  resume: () => {},
  stop: () => {},
  nextChunk: () => {},
  prevChunk: () => {},
  seekToChunk: () => {},
  setPlaybackRate: () => {},
  setVolume: () => {},
  toggleMute: () => {},
  toggleBackgroundMusic: () => {},
  dismiss: () => {},
  registerScrollCallback: () => {},
  scrollToCurrent: () => {},
});
